<app-module>
  <div class="header" header>
    {{ 'SETTINGS.header' | translate }}
    <app-chips-list-notResponsive class="tab-indicator">
      <app-chip-notResponsive (select)="currentTab = 0" selected="true">{{ 'SETTINGS.accountBtn' | translate }}</app-chip-notResponsive>
      <app-chip-notResponsive (select)="currentTab = 1">{{ 'SETTINGS.passwordBtn' | translate }}</app-chip-notResponsive>
    </app-chips-list-notResponsive>
  </div>

  <div class="tab-container">
    <div class="tab" *ngIf="currentTab == 0">
      <form [formGroup]="profileForm" (ngSubmit)="saveSettings($event)" class="form-container">
        <div class="input-row">
          <app-input [type]="'info'">
            {{ 'SETTINGS.labelCompany' | translate }}
            <div info>{{ user?.company?.title }}</div>
          </app-input>

          <app-input [type]="'info'" *ngIf="user?.branchoffice?._id">
            {{ 'SETTINGS.labelBranch' | translate }}
            <div info>{{ user?.branchoffice?.title }}</div>
          </app-input>
        </div>

        <div class="input-row">
          <app-input>
            {{ 'SETTINGS.labelTitle' | translate }}
            <select [formControlName]="'title'" name="" id="">
              <option value="none" selected>{{ 'SETTINGS.titleOptionNone' | translate }}</option>
              <option value="male">{{ 'SETTINGS.titleOptionMale' | translate }}</option>
              <option value="female">{{ 'SETTINGS.titleOptionFemale' | translate }}</option>
            </select>
          </app-input>

          <app-input [error]="profileForm.controls['alias'].invalid && profileForm.controls['alias'].touched">
            {{ 'SETTINGS.labelAlias' | translate }}
            <input
              [formControlName]="'alias'"
              type="text"
              placeholder="{{ 'SETTINGS.placeholderAlias' | translate }}"
            />
            <div app-input-error *ngIf="profileForm.controls['alias'].invalid && profileForm.controls['alias'].touched">
              {{ 'GENERAL.FORMS.aliasInvalid' | translate }}
            </div>
          </app-input>
        </div>

        <div class="input-row">
          <app-input [error]="profileForm.controls['prename'].invalid && profileForm.controls['prename'].touched">
            {{ 'SETTINGS.labelPrename' | translate }}
            <input
              [formControlName]="'prename'"
              type="text"
              placeholder="{{ 'SETTINGS.placeholderPrename' | translate }}"
            />
            <div
              app-input-error
              *ngIf="profileForm.controls['prename'].invalid && profileForm.controls['prename'].touched"
            >
              {{ 'GENERAL.FORMS.prenameInvalid' | translate }}
            </div>
          </app-input>

          <app-input [error]="profileForm.controls['surname'].invalid && profileForm.controls['surname'].touched">
            {{ 'SETTINGS.labelSurname' | translate }}
            <input
              type="text"
              [formControlName]="'surname'"
              placeholder="{{ 'SETTINGS.placeholderSurname' | translate }}"
            />
            <div
              app-input-error
              *ngIf="profileForm.controls['surname'].invalid && profileForm.controls['surname'].touched"
            >
              {{ 'GENERAL.FORMS.surnameInvalid' | translate }}
            </div>
          </app-input>
        </div>

        <div class="input-row">
          <app-input [type]="'info'">
            {{ 'SETTINGS.labelEmail' | translate }}
            <div info>{{ user?.email }}</div>
          </app-input>

          <app-input>
            {{ 'SETTINGS.labelLanguage' | translate }}
            <select name="" id="" [formControlName]="'language'">
              <option value="de">{{ 'SETTINGS.languageOptionGerman' | translate }}</option>
              <option value="en">{{ 'SETTINGS.languageOptionEnglish' | translate }}</option>
            </select>
          </app-input>
        </div>

        <div class="input-row">
          <app-input type="checkbox" style="float: right">
            {{ 'SETTINGS.labelCaption' | translate }}
            <input type="checkbox" formControlName="caption">
          </app-input>
        </div>

        <div class="input-row">
          <app-input>
            {{ 'SETTINGS.labelTimezone' | translate }}
            <select [formControlName]="'timezone'" class="selectpicker" #tzpicker data-live-search="true">
              <option value="{{ zone.value }}" *ngFor="let zone of timezones">{{ zone.text }}</option>
            </select>
          </app-input>

          <app-input>
            {{ 'SETTINGS.mailFormatLabel' | translate }}
            <select name="" id="" [formControlName]="'emailFormat'">
              <option value="HTML">{{ 'SETTINGS.formatOptionHtml' | translate }}</option>
              <option value="Text">{{ 'SETTINGS.formatOptionText' | translate }}</option>
            </select>
          </app-input>
        </div>

        <div class="buttons">
          <button (click)="cancelSave($event)" routerLink="/dashboard" mat-button type="button">
            {{ 'SETTINGS.buttonCancel' | translate }}
          </button>
          <button mat-raised-button color="accent" type="submit">{{ 'SETTINGS.buttonSave' | translate }}</button>
        </div>
      </form>
    </div>

    <div class="tab" *ngIf="currentTab == 1">
      <div class="form-container">
        <form [formGroup]="passwordForm" (ngSubmit)="submitPasswordForm($event)">
          <div class="input-row">
            <app-input
              [error]="passwordForm.controls['oldPassword'].invalid && passwordForm.controls['oldPassword'].touched"
            >
              {{ 'SETTINGS.labelOldPwd' | translate }}
              <input [formControlName]="'oldPassword'" type="password" />
              <div
                app-input-error
                *ngIf="passwordForm.controls['oldPassword'].invalid && passwordForm.controls['oldPassword'].touched"
              >
                {{ 'GENERAL.FORMS.requiredInvalid' | translate }}
              </div>
            </app-input>
          </div>

          <div class="input-row">
            <app-input [error]="passwordForm.controls['password'].invalid && passwordForm.controls['password'].touched">
              {{ 'SETTINGS.labelNewPwd' | translate }}
              <input [formControlName]="'password'" type="password" />
              <div
                app-input-error
                *ngIf="passwordForm.controls['password'].invalid && passwordForm.controls['password'].touched"
              >
                {{ 'GENERAL.FORMS.passwordInvalid' | translate }}<br />
                {{ 'GENERAL.FORMS.passwordRequirements' | translate }}
              </div>
            </app-input>
            <app-input
              [error]="
                passwordForm.controls['confirmPassword'].invalid && passwordForm.controls['confirmPassword'].touched
              "
            >
              {{ 'SETTINGS.labelRepeatPwd' | translate }}
              <input [formControlName]="'confirmPassword'" type="password" />
              <div
                app-input-error
                *ngIf="
                  passwordForm.controls['confirmPassword'].invalid && passwordForm.controls['confirmPassword'].touched
                "
              >
                {{ 'GENERAL.FORMS.passwordConfirmInvalid' | translate }}
              </div>
            </app-input>
          </div>

          <div class="buttons">
            <button (click)="cancelSave($event)" routerLink="/dashboard" mat-button type="button">
              {{ 'SETTINGS.buttonCancel' | translate }}
            </button>
            <button mat-raised-button color="accent" type="submit">{{ 'SETTINGS.buttonSave' | translate }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</app-module>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/settings/settings.component.html